import * as utils from '../../../shared';

export function footnotes(words: string[], shortFunction: (word: string) => string) {
  
  return utils.footnotes(words, shortFunction);
}